import { render, staticRenderFns } from "./ClockSolid.vue?vue&type=template&id=1fd889e4&"
import script from "./ClockSolid.vue?vue&type=script&lang=ts&"
export * from "./ClockSolid.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports